import { Link } from "react-router-dom";
import PageLayout from "../../components/layout/PageLayout";
import TrendingBar from "../../components/football/TrendingBar";
import SuperBowlCountdown from "../../components/football/SuperBowlCountdown";
import { HERO_IMAGES } from "../../lib/constants";
import { Trophy, Shield } from "lucide-react";

export default function SuperBowl() {
    return (
        <PageLayout>
            <section className="relative min-h-[60vh] flex items-end pt-24 pb-14 overflow-hidden border-b border-white/10">
                <img src={HERO_IMAGES.stadium_lights} alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/30" />
                <div className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-10">
                    <div className="section-label mb-5">The Big Game</div>
                    <h1 className="font-display text-6xl md:text-8xl text-white leading-[0.88] tracking-tight" data-testid="sb-heading">
                        ROAD TO THE<br/><span className="text-[#d4af37]">SUPER BOWL.</span>
                    </h1>
                </div>
            </section>

            <TrendingBar />

            <section className="py-14">
                <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-2 gap-6 items-start">
                    <SuperBowlCountdown />
                    <div className="space-y-4">
                        <div className="surface p-6" data-testid="playoff-picture">
                            <div className="section-label mb-3">Playoff Picture</div>
                            <p className="text-white/60 leading-relaxed">
                                As the season progresses, Digital Beast will publish weekly playoff bracket updates for both the AFC and NFC, plus wild-card seeding, tiebreakers and prediction pieces.
                            </p>
                        </div>
                        <div className="grid md:grid-cols-2 gap-3">
                            <div className="surface p-6" data-testid="afc-race">
                                <Shield className="text-[#d4af37]" size={22} />
                                <div className="font-display text-2xl text-white mt-4">AFC Race</div>
                                <div className="text-white/40 text-xs mt-2 uppercase tracking-widest">Editor updates weekly</div>
                            </div>
                            <div className="surface p-6" data-testid="nfc-race">
                                <Trophy className="text-[#d4af37]" size={22} />
                                <div className="font-display text-2xl text-white mt-4">NFC Race</div>
                                <div className="text-white/40 text-xs mt-2 uppercase tracking-widest">Editor updates weekly</div>
                            </div>
                        </div>
                        <Link to="/football/nfl" className="btn-outline w-full justify-center" data-testid="sb-back-nfl">NFL Standings & Scoreboard</Link>
                    </div>
                </div>
            </section>
        </PageLayout>
    );
}
